export enum PaymentFrequency {
  WEEK01 = 1,
  FORT01 = 2,
  MONT01 = 4,
  HAYE01 = 6,
  YEAR01 = 12,
}
